<template>
    <vs-prompt buttons-hidden	class="large" :title="formData.id ? 'تعديل المحاضرة' : 'إضافة محاضرة جديدة'"
              :active="active" @close="close">

      <h4 class="mb-6">قم بادخال بيانات المحاضرة</h4>

      <div class="vx-row">
        <div class="vx-col mb-6 md:w-3/4 w-full">
          <vs-input class="w-full" label="العنوان" v-model="formData.title"
                    v-validate="'required'"  name="title" data-vv-as="العنوان" />
          <span class="text-danger text-sm" v-show="errors.has('title')">{{ errors.first('title') }}</span>
        </div>
        <div class="vx-col mb-6 md:w-1/4 w-full">
          <label>عرض المحاضرة</label>
          <ul class="centerx flex">
            <li>
              <vs-switch v-model="formData.is_visible" color="primary" />
            </li>
          </ul>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <label>تاريخ إلقاء المحاضرة</label>
          <flat-pickr class="w-full" :config="configDateTimePicker" v-model="formData.date"
                      v-validate="'required'" name="date" data-vv-as="التاريخ" />
          <span class="text-danger text-sm" v-show="errors.has('date')">{{ errors.first('date') }}</span>
        </div>
        <div class="vx-col mb-6">
          <label>مجموعات المادة</label>
          <ul class="centerx flex flex-wrap">
            <li v-for="(group, index) in getCourseDetails.groups" :key="index">
              <vs-checkbox v-model="formData.groups" :vs-value="group.group"
                           v-validate="'required'" name="groups" data-vv-as="المجموعات" data-vv-validate-on="change">
                {{group.group}}
              </vs-checkbox>
            </li>
          </ul>
          <span class="text-danger text-sm" v-show="errors.has('groups')">يجب اختيار مجموعة واحده علي الاقل</span>
        </div>
      </div>
      <vs-divider />
      <div class="flex justify-end">
        <vs-button @click="close" class="mx-5" type="flat">رجوع</vs-button>
        <vs-button @click="submitClicked">حفظ</vs-button>
      </div>
    </vs-prompt>
</template>
<script>

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import { Arabic } from "flatpickr/dist/l10n/ar.js"

    import lecturesAPI from "@/api/lecturesAPI";

    export default {
        name: 'lecture-form',
        props: {
            lecture: {
                default: null,
                type: Object
            },
            active: {
                required: true,
                default: false,
                type: Boolean
            }
        },
        watch: {
            active(newVal) {
                if(!newVal) return

                this.initValues()

                if(this.lecture){
                    Object.assign(this.formData, this.lecture)
                    delete this.formData.files
                }
            }
        },
        data() {
            return {
                formData: {
                    groups: [],
                    title: '',
                    date: null,
                    is_visible: true,
                },
                configDateTimePicker: {
                    disableMobile: "true",
                    dateFormat: 'Y-m-d',
                    locale: Arabic,
                },
            }
        },
        methods: {
            initValues(){
                this.formData = {
                    groups: [],
                    title: '',
                    date: this.$store.state.date,
                    is_visible: true,
                }
                this.$validator.reset()
            },
            submitClicked(){

                this.$validator.validateAll().then((result) => {
                    if(result) {
                        this.$startLoading()
                        if(this.formData.id){
                            this.updateLecture()
                        } else {
                            this.addLecture()
                        }
                    }
                })

            },
            addLecture(){
                // let $this = this
                lecturesAPI.create(this.formData)
                    .then( response => {
                        this.formData.id = response.data.id
                        this.$notifySuccess(response.successMessage)
                        // this.$vs.notify({
                        //     text: response.successMessage + " <b class='cursor-pointer'>عرض</b>",
                        //     color: 'success',
                        //     iconPack: 'feather',
                        //     icon: 'icon-check',
                        //     position: 'bottom-center',
                        //     time: 8000,
                        //     click: () => $this.lectureClicked(this.formData.id)
                        // })
                        this.submitRequest()
                    })
                    .catch(error => this.$notifyError(error.statusMessage))
                    .finally(() => this.$closeLoading())
            },
            updateLecture(){
                lecturesAPI.update(this.formData.id, this.formData)
                    .then( () => this.submitRequest())
                    .catch(error => this.$notifyError(error.statusMessage))
                    .finally(() => this.$closeLoading())
            },
            submitRequest(){
                let data = {}
                Object.assign(data, this.formData)
                this.$emit('submit', data)
                this.close()
            },
            close(){
                this.$emit('update:active',false)
            },
        },
        components: {
            flatPickr,
        },
    }
</script>
